import { CliUser } from "../types/users";
// import config from "./config.json";

import Person from "@mui/icons-material/Person"
import Leaderboard from "@mui/icons-material/Leaderboard"
import AutoAwesome from "@mui/icons-material/AutoAwesome"
import Storefront from "@mui/icons-material/Storefront"
// import SportsEsports from "@mui/icons-material/SportsEsports"
import Badge from "@mui/icons-material/Badge"
import MonochromePhotos from "@mui/icons-material/MonochromePhotos"
import Image from "@mui/icons-material/Image"
import Chat from "@mui/icons-material/Chat"
import QuestionAnswer from "@mui/icons-material/QuestionAnswer"
import Plumbing from "@mui/icons-material/Plumbing"
import LocalOffer from "@mui/icons-material/LocalOffer"

const items = [
    {
        name: "Store",
        icon: <Storefront/>,
        link: "store"
    }   
]

// if (config.tournamentReady) {
//     items.push({
//         name: "Tournaments",
//         icon: <SportsEsports/>,
//         link: "tournaments"
//     });
// }

function Daedalus() {
    return (
        <div style={{ width: "24px", height: "24px", objectFit: "fill" }}>
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 57.986884 72.223184"
                version="1.1"
                id="svg197"
                xmlns="http://www.w3.org/2000/svg">
                <defs
                    id="defs194" />
                <g
                    id="layer1"
                    transform="translate(-88.391864,-47.865907)">
                    <path
                    style={{ fill: "var(--joy-palette-text-icon)", strokeWidth: 0.264583, fillOpacity:1 }}
                    d="m 115.89302,73.65467 c -0.51778,0.211769 -0.62985,0.423023 -0.56143,1.058333 0.047,0.436562 0.14517,2.423684 0.21815,4.415827 l 0.13269,3.622074 -1.1442,0.838928 c -0.62931,0.461407 -2.6084,1.544979 -4.39799,2.407933 -2.9324,1.414039 -3.33125,1.691177 -4.03819,2.805907 -0.88088,1.389004 -1.31735,2.722843 -1.27651,3.900998 0.0228,0.657704 0.066,0.598037 0.25228,-0.348128 0.29933,-1.520683 1.15081,-2.844329 2.42214,-3.765275 3.40384,-2.465729 8.42125,0.180385 8.4018,4.430993 -0.0168,3.662005 -3.52974,6.335919 -6.9395,5.28202 -1.55961,-0.48205 -1.62087,-0.315053 -0.13229,0.36064 1.38139,0.627039 3.80574,0.679696 5.16787,0.112247 1.25049,-0.520941 2.85404,-2.062935 3.56344,-3.426664 0.58252,-1.119812 0.73521,-2.92789 0.4029,-4.771012 l -0.19235,-1.066845 4.35385,-2.849882 9.7201,-6.640171 2.18575,-1.49786 0.45608,1.004552 c 0.7234,1.593334 0.61154,3.455837 -0.29325,4.882541 -0.88361,1.393299 -2.10746,2.361258 -8.6295,6.825208 -5.18692,3.550137 -6.0663,4.262228 -6.65445,5.388531 -0.38152,0.730588 -0.36,0.779452 1.04881,2.38125 0.79108,0.899444 2.70802,2.945045 4.25987,4.545775 2.6422,2.72542 2.81041,2.85243 2.64646,1.99823 -0.60704,-3.16273 0.62834,-6.306695 2.91264,-7.412508 1.50026,-0.726266 2.20754,-0.679895 3.65778,0.239818 1.51784,0.962586 2.15037,2.08409 1.92467,3.41252 -0.18824,1.10795 -1.44135,3.5292 -1.90306,3.67708 -0.19537,0.0626 -0.47152,-0.66198 -0.74944,-1.96636 -0.51783,-2.43032 -0.91289,-3.785241 -1.10368,-3.785241 -0.45909,0 -1.76536,1.258531 -2.20913,2.128411 -1.05767,2.07319 -0.54637,3.89659 1.9628,6.9997 2.19751,2.71769 3.17041,4.81982 3.16569,6.84002 -0.008,3.61943 -2.22112,5.13155 -5.71781,3.90751 -1.51304,-0.52965 -1.52954,-0.52975 -3.01799,-0.0176 -1.32555,0.45606 -2.24619,0.51492 -8.05417,0.51492 -3.60665,0 -6.6208,-0.10234 -6.6981,-0.22741 -0.16647,-0.26935 1.04242,-2.77886 1.53595,-3.18846 0.24644,-0.20452 0.70715,-0.1808 1.64082,0.0845 1.92879,0.54807 3.24071,0.73446 3.83715,0.54516 0.46762,-0.14842 0.29316,-0.41811 -1.45206,-2.24482 -2.62388,-2.74638 -3.17995,-3.83189 -3.19323,-6.23346 -0.009,-1.60809 0.0855,-1.99942 0.66985,-2.77811 1.11896,-1.49099 1.18064,-1.70429 0.31447,-1.08752 -0.83021,0.59116 -1.97279,1.83279 -2.41698,2.62651 -0.21435,0.38302 -0.37542,0.39318 -1.39439,0.0879 -0.63363,-0.18981 -2.22173,-0.80627 -3.52912,-1.36989 -2.26377,-0.97592 -2.39913,-1.0027 -2.84003,-0.56179 -0.86525,0.86524 -3.32775,6.63709 -3.65212,8.56021 -0.2885,1.71043 -0.364,1.85263 -1.057086,1.99125 -0.46871,0.0937 -0.79969,0.36005 -0.88965,0.71581 -0.0788,0.3116 -0.50254,1.13208 -0.94167,1.82331 l -0.79842,1.25677 h -4.23916 c -3.21547,0 -4.23892,-0.0799 -4.23817,-0.33073 l -4e-5,-1e-5 c 0.001,-0.41517 0.94282,-1.99774 1.63996,-2.75636 0.45258,-0.4925 0.7232,-0.5533 1.91505,-0.4303 1.31372,0.13559 1.43702,0.0942 2.30448,-0.77324 1.47606,-1.47606 2.01375,-3.83964 2.15382,-9.4677 0.11728,-4.71273 -0.13899,-7.62402 -0.97818,-11.112499 -0.51649,-2.147011 -0.53913,-5.027228 -0.0487,-6.200888 0.20503,-0.490723 0.80321,-1.528697 1.32928,-2.306606 1.22448,-1.810666 2.26667,-5.070893 2.26667,-7.090699 0,-1.498375 -0.0267,-1.55726 -0.83323,-1.838423 -0.45828,-0.159758 -1.34532,-0.290467 -1.97121,-0.290467 -1.02488,0 -1.23688,0.11833 -2.13321,1.190625 -0.54738,0.654844 -1.07733,1.190625 -1.17766,1.190625 -0.10033,0 -0.44947,-0.446484 -0.77586,-0.992188 -0.8347,-1.395555 -0.79619,-2.942354 0.10564,-4.243702 l 0.711,-1.02597 2.04508,0.115556 c 1.93373,0.109265 2.08,0.07805 2.68651,-0.573236 0.72683,-0.780491 0.43663,-0.869963 -0.94683,-0.291918 -0.52242,0.218281 -1.35203,0.396875 -1.84358,0.396875 -0.8073,0 -0.89373,-0.07331 -0.89373,-0.758069 0,-0.416938 0.23054,-1.051149 0.5123,-1.409357 1.21096,-1.539478 5.52403,-3.143375 9.508806,-3.536025 2.09059,-0.206001 2.14661,-0.154474 1.44092,1.325375 -0.44079,0.924329 -0.43798,0.940278 0.36245,2.059497 2.00416,2.802352 3.31058,6.359351 3.86406,10.520662 0.30365,2.282957 0.38877,2.521371 0.92791,2.598886 0.4954,0.07122 0.70202,-0.159825 1.24899,-1.396609 0.76563,-1.731229 0.80747,-2.632035 0.23632,-5.088464 -0.24728,-1.063524 -0.35119,-2.229559 -0.25347,-2.844509 0.27212,-1.71245 1.74076,-4.114635 3.72647,-6.0952 1.93151,-1.926496 3.10377,-2.782151 11.10127,-8.102988 2.61938,-1.742702 7.85813,-5.303408 11.64167,-7.912678 3.78354,-2.609271 6.97454,-4.747817 7.09111,-4.752325 0.37917,-0.01466 1.02278,1.904173 1.02278,3.049285 0,2.434528 -1.10648,3.572427 -8.2538,8.48821 m -15.08621,11.430022 c 1.0175,-0.736263 15.33852,-10.787065 17.82016,-12.506565 1.42673,-0.988561 2.63197,-1.754234 2.67833,-1.701495 0.48246,0.548855 0.94534,2.027251 0.94534,3.019325 0,2.737504 -0.91895,3.643649 -10.1864,10.044509 -7.59914,5.24859 -8.33242,5.685179 -9.54861,5.685179 -1.25439,0 -1.60074,0.5719 -1.21647,2.008656 0.17269,0.645665 0.31398,1.63099 0.31398,2.189607 v 1.015669 l -4.4752,2.97306 c -4.22827,2.809015 -5.44667,3.351244 -5.44667,2.423946 0,-0.199113 1.78593,-1.566701 3.96874,-3.039084 l 3.96875,-2.677062 0.1323,-3.96875 c 0.0728,-2.182813 0.2388,-4.134058 0.36897,-4.3361 m 9.45412,45.445247 c 0.47763,-0.47763 0.541,-0.7732 0.41907,-1.95461 -0.079,-0.76553 -0.34794,-1.79223 -0.59761,-2.28155 -0.53277,-1.04413 -2.82193,-4.22865 -2.94864,-4.10194 -0.0479,0.0479 0.0997,0.61161 0.32797,1.25278 0.22824,0.64116 0.4833,2.4159 0.5668,3.94387 0.19489,3.56638 0.86479,4.50907 2.23241,3.14145 z M 116.4954,88.027328 c -0.17781,-0.177807 -0.32329,-0.410503 -0.32329,-0.517106 0,-0.106601 2.02407,-1.526498 4.49792,-3.155323 l 4.49792,-2.961503 v -1.498195 c 0,-2.865972 0.39322,-3.300656 7.26452,-8.03048 3.34064,-2.299516 6.24713,-4.147176 6.45887,-4.105911 0.46553,0.09073 1.04547,1.601428 1.07314,2.795504 0.0492,2.122507 -1.26667,3.745325 -5.39739,6.656416 l -17.35676,10.989588 c -0.21541,0.08266 -0.53713,0.0048 -0.71493,-0.17299 z m 0.56785,-6.695283 c -0.29727,-0.774687 0.10375,-5.06742 0.5549,-5.939838 0.39589,-0.765588 2.32072,-2.398996 2.82699,-2.398996 0.12369,0 0.22489,1.472459 0.22489,3.272131 v 3.272134 l -0.99219,0.651873 c -2.62959,1.72766 -2.42451,1.63803 -2.61459,1.142696 z"
                    id="path267"
                    />
                </g>
            </svg>
        </div>
    )
}

export default function SidebarItems(user: CliUser, mode: string | undefined) {
    const perms = user.perms;
    let mi = [{
        name: "Profile",
        icon: <Person/>,
        link: `profile/${user.id}`
    }, {
        name: "Leaderboard",
        icon: <Leaderboard/>,
        link: "leaderboard"
    }];

    if (!perms.isSponsor || perms.isProSponsor) {
        mi.push({
            name: "Sponsor Perks",
            icon: <AutoAwesome/>,
            link: "sponsor"
        })
    }
    
    mi.push(...items)
    
    if (perms.isMgr) mi.push({
        name: "Tags",
        icon: <LocalOffer/>,
        link: "tags"
    })

    if (perms.isMod) {
        mi.push({
            name: "Name Audit",
            icon: <Badge/>,
            link: "mod/names"
        })
        mi.push({
            name: "PFP Audit",
            icon: <MonochromePhotos/>,
            link: "mod/pfps"
        })
    }

    if (perms.isMgr) mi.push({
        name: "Reports",
        icon: <Plumbing/>,
        link: "reports"
    })
    // if (perms.isMgr) mi.push({
    //     name: "Manager Tools",
    //     icon: <Plumbing/>,
    //     link: "manager"
    // })

    // if (perms.isMgmt) mi.push({
    //     name: "Chat Filters",
    //     icon: <SmsFailed/>,
    //     link: "management/filters"
    // })

    if (perms.isOwner) {
        mi.push({
            name: "Chatterbox",
            icon: <Chat/>,
            link: "chatterbox"
        })
    }

    mi.push({
        name: "Daedalus",
        icon: <Daedalus/>,
        link: "daedalus3"
    })

    mi.push({
        name: "Wallpapers",
        icon: <Image/>,
        link: "wallpapers"
    })

    mi.push({
        name: "Survey",
        icon: <QuestionAnswer/>,
        link: "survey"
    })

    return mi;
}